import React, { useState } from "react";
import { FaLinkedin, FaSalesforce } from "react-icons/fa";
import ContactIcon from "../assets/contactImages/ContactIcon.svg"
import { db } from "../firebase-config.js";
import { collection, addDoc } from "firebase/firestore";

function Contact() {
  const socials = [
    { href: "https://www.linkedin.com/in/tylerolsen14/", icon: <FaLinkedin />},
    { href: "https://www.salesforce.com/trailblazer/tolsen30", icon: <FaSalesforce /> }
  ]

const [success, setSuccess] = useState("");
const [name, setName] = useState("");
const [email, setEmail] = useState("");
const [message, setMessage] = useState("");

const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Form submitted!");
  const formData = {
    name,
    email,
    message,
    createdAt: new Date()
  }

  try {
    await addDoc(collection(db, "contactMessages"), formData);
    console.log("Message saved!");
    // Clear the form
    setName("");
    setEmail("");
    setMessage("");
    // Show success message
    setSuccess("Thank you for your message!");
    //Hide after 3 seconds
    setTimeout(() => setSuccess(""), 3000);
  } catch (error) {
    console.log("Error saving message: ", error);
  }
};

return (
  <div className="contactPage">
    <h2>Contact Me</h2>
    <div className="contactRow">
      <div className="contactHeader">
        <img src={ContactIcon} />
        <div className="socialIcons">
          {socials.map((s,i) => (
            <a key={i} href={s.href} target="_blank" rel="noopener noreferrer">
              {s.icon}
            </a>
          ))}
        </div>
      </div>
      <div className="contactColumn">
        <div className="contactAnnouncement">
          {/* <h3>I would love to hear from you!</h3> */}
          <p>Please fill out this form. I will be in touch with you as soon as I am available. </p>
        </div>
        <div className="contactForm">
          {success && (
            <p className="success-message" style={{ color: "green", fontSize: "20px" }}>{success}</p>
          )}
          <form onSubmit={handleSubmit}>
            <label for="name">Name: </label>
              <input 
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              /><br />
            <label for="email">Email: </label>
              <input 
                type="email" 
                id="email" 
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              /><br />
            <label for="message">Message: </label>
              <textarea
                type="textarea"
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              /><br />
            <input type="submit" value="Submit"></input>
          </form>
        </div> 
      </div>
    </div>
  </div>
  );
}

export default Contact;